import styled from "styled-components";
import { VerticalLine } from "./components/lines";
import { FancyButton } from "./components/button";
import {
  useContattiQuery,
  useNuovoRistoranteQuery,
} from "../../generated/graphql";
import { useState } from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  padding: 50px 100px;
  max-width: 900px;
  box-sizing: border-box;

  & > img {
    height: 80px;
  }
  width: 100%;
`;
const ContainerInputs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  input {
    background-color: transparent;
    border: 1px solid #c0c0b0; // light border, slightly desaturated
    color: white; // matching the border color for text
    font-family: "Open Sans", sans-serif;

    padding: 20px;
    outline: none;
    width: 100%;
    max-width: 5000px;
    box-sizing: border-box;
    ::placeholder {
      color: #c0c0b0;
      opacity: 0.5;
      font-family: "Open Sans", sans-serif;
    }
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
const SendButton = styled(FancyButton)`
  color: #051f20;
  background-color: #a2a087;
`;
const FlexLogo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 20px;
  & > img {
    height: 80px;
    object-fit: contain;
  }
  justify-content: space-between;
  p {
    max-width: 450px;
    /* Iscriviti alla newsletter per restare aggiornato su tutte le novità e sulle serate degusstazione del nostro ristorante. */

    font-family: "Josefin Sans";
    font-style: normal;
    font-size: 25px;
    font-weight: "300";
    color: #a2a087;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
export function NewsLetter() {
  const [formData, setFormData] = useState({
    FNAME: "",
    LNAME: "",
    EMAIL: "",
    tags: "11241836",
  });
  const { data } = useNuovoRistoranteQuery();

  return (
    <Container>
      <VerticalLine height="50px" />
      <img src="/kum/letter.webp"></img>
      <FlexLogo>
        <img src="/kum/logo.webp"></img>
        <p>{data?.nuovoRistorante?.testoNewsletter}</p>
      </FlexLogo>
      <MailchimpSubscribe
        url={
          "https://thepadelresort.us14.list-manage.com/subscribe/post?u=fc95bebb5e17453f8c556fef9&amp;id=a125892e9a&amp;f_id=0079b6e5f0"
        }
        render={({ subscribe, status, message }) => (
          <ContainerInputs>
            <input
              placeholder="NOME"
              onChange={(val) =>
                setFormData({ ...formData, FNAME: val.target.value })
              }
              value={formData.FNAME}
            />
            <input
              placeholder="COGNOME"
              value={formData.LNAME}
              onChange={(val) =>
                setFormData({ ...formData, LNAME: val.target.value })
              }
            />
            <input
              placeholder="EMAIL"
              type="email"
              onChange={(val) =>
                setFormData({ ...formData, EMAIL: val.target.value })
              }
              value={formData.EMAIL}
            />{" "}
            {status !== "success" ? (
              <SendButton
                onClick={() => subscribe(formData)}
                disabled={
                  formData.EMAIL === "" ||
                  formData.FNAME === "" ||
                  formData.LNAME === ""
                }
              >
                {status === "sending" ? "Sto Inviando" : "Invia"}
              </SendButton>
            ) : (
              <>{"Registered!"}</>
            )}
          </ContainerInputs>
        )}
      />
    </Container>
  );
}
